import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImage } from "@fortawesome/free-solid-svg-icons";
import "./Media.css";

/* ---------------------------------------------------------------------------
   Figure — every picture slot on the site.

   Give it a `src` and it renders the photograph with a slow drift so it is
   never completely still. Leave `src` off and it renders a placeholder that
   is designed rather than grey: a moving mesh of the four college colours,
   with the shot it wants and the size it should be. Drop a file in and the
   placeholder disappears — nothing else changes.

     <Figure ratio="4/3" label="Moot court session" size="1200×900" />
     <Figure ratio="4/3" src={mootCourt} alt="Students in the moot court" />
     <Figure ratio="4/3" art={<Optometry />} />   // a drawing, where no photo exists
--------------------------------------------------------------------------- */

/* A page can carry a dozen empty slots at once. Seeding the mesh from the
   label gives each one a different arrangement of the four lights, so a wall
   of placeholders reads as a wall of different pictures rather than tiling. */
const variantOf = (label) => {
  let h = 0;
  for (let i = 0; i < label.length; i += 1) h = (h * 31 + label.charCodeAt(i)) % 4;
  return h + 1;
};

const Figure = ({
  src,
  art,
  alt = "",
  ratio = "4 / 3",
  label = "Add a photo",
  size,
  className = "",
  round = false,
  still = false,
}) => (
  <div
    className={`figure ${round ? "figure--round" : ""} ${className}`}
    style={{ "--ratio": ratio }}
  >
    {src ? (
      <img
        src={src}
        alt={alt}
        className={`figure-img ${still ? "" : "drift"}`}
        loading="lazy"
      />
    ) : art ? (
      art
    ) : (
      <div
        className={`ph ph--v${variantOf(label)}`}
        role="img"
        aria-label={`Image placeholder: ${label}`}
      >
        <span className="ph-mesh" aria-hidden="true" />
        <span className="ph-grid" aria-hidden="true" />
        <span className="ph-body">
          <span className="ph-icon">
            <FontAwesomeIcon icon={faImage} />
          </span>
          <span className="ph-label">{label}</span>
          {size && <span className="ph-size figures">{size}</span>}
        </span>
      </div>
    )}
  </div>
);

export default Figure;
